module.exports = __webpack_public_path__ + "static/media/play.954537a2.svg";